import * as React from "react";
import { cs } from "../../core/classSet";
import useIntersection from "../../core/hooks/useIntersection";
import { useDesktopMediaQuery } from "../../core/hooks/useMediaQuery";
import { IIndustry, ITopic } from "../../typings/filterEntities";
import FilterBar from "../FilterBar/FilterBar";
import Navbar from "../Navbar/Navbar";
import styles from "./SiteHeader.module.css";

interface IHomeHeaderProps extends IHeaderProps {
  filterBarRef: React.RefObject<HTMLDivElement>;
  topics: ITopic[];
}

const intersectionObserverOptions = {
  root: null,
  rootMargin: "-66px",
  threshold: 0,
};

export function HomeHeader({ filterBarRef, industries, topics }: IHomeHeaderProps) {
  const [showFilterBar, setShowFilterBar] = React.useState(false);

  const filterBarIntersection = useIntersection(filterBarRef, intersectionObserverOptions);
  const isDesktopViewport = useDesktopMediaQuery();

  React.useEffect(() => {
    // need to check for window.CSS to support IE11
    if (
      typeof window.CSS === "object" &&
      window.CSS.supports("display: grid") &&
      filterBarIntersection
    ) {
      if (filterBarIntersection.isIntersecting || !isDesktopViewport) {
        setShowFilterBar(false);
      } else if (
        // attempt at only showing the filter bar when scrolling down the page
        filterBarIntersection.boundingClientRect.y <
          filterBarIntersection.boundingClientRect.height &&
        isDesktopViewport
      ) {
        setShowFilterBar(true);
      }
    }
  }, [filterBarIntersection, isDesktopViewport]);

  if (showFilterBar) {
    return (
      <header className={cs(styles.root, styles.rootFilter)}>
        <FilterBar industries={industries} topics={topics} location="homeHeader" />
      </header>
    );
  }

  return <SiteHeader industries={industries} />;
}

interface IHeaderProps {
  industries: IIndustry[];
}

export default function SiteHeader({ industries }: IHeaderProps) {
  return (
    <header className={styles.root}>
      <Navbar industries={industries} />
    </header>
  );
}
